import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredVolatilityHigh = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M9.96703 5.33811L10.9142 4.29948L12.2944 5.31893C12.3424 4.9525 12.3228 4.57916 12.236 4.22098C12.1365 3.7524 11.9131 3.32486 11.5931 2.98988C11.2731 2.6549 10.8701 2.42674 10.4325 2.33307C10.4882 2.0476 10.6043 1.77974 10.772 1.55047C11.049 1.21259 11.4451 1.0161 11.8635 1.00897L11.7914 0C11.458 0.0124894 11.1307 0.0996924 10.8302 0.25581C10.5298 0.411928 10.2628 0.633838 10.0461 0.907045C9.74783 1.31518 9.55285 1.79982 9.47999 2.31344C7.48049 2.63861 7.22217 4.90879 7.22217 4.90879L8.83212 4.08159L9.96703 5.33811Z"
      fill="url(#paint0_linear_2264_24866)"
    />
    <path
      d="M15.3597 12.2472L15.3144 12.2283C14.575 11.9283 13.9058 11.4568 13.3542 10.8471C12.8748 10.2944 12.5161 9.63313 12.3048 8.91142C12.0882 8.28539 11.9537 7.6297 11.9051 6.96352C11.8808 6.5284 11.8866 6.09193 11.9224 5.65748L10.973 4.95651L9.96455 6.06205L8.73049 4.69513L7.53865 5.30555C7.43143 6.04867 7.4275 6.80472 7.52706 7.54918C7.70321 8.88444 8.21364 10.143 9.00371 11.1894C9.77888 12.1779 10.7706 12.9426 11.8891 13.4139C12.152 13.533 12.4221 13.6322 12.6976 13.7114C12.9644 13.7997 13.2366 13.8673 13.5123 13.9139C14.0519 14.0073 14.6007 14.0247 15.1444 13.9661C15.3928 13.9389 15.6166 13.7926 15.7534 13.5675C15.8902 13.3425 15.9256 13.063 15.8494 12.8068C15.7735 12.5505 15.594 12.3451 15.3613 12.2474L15.3597 12.2472Z"
      fill="url(#paint1_linear_2264_24866)"
    />
    <path
      d="M5.89784 4.72033C5.89784 4.72033 6.05447 3.28769 7.05265 2.44915C6.93658 2.39942 6.81672 2.36017 6.69409 2.33274C6.74755 2.04728 6.85906 1.77944 7.02006 1.55018C7.286 1.21231 7.66643 1.01583 8.06813 1.0087L7.99876 0C7.67856 0.0124888 7.36431 0.0996877 7.07571 0.255798C6.78731 0.411909 6.5309 0.633808 6.3228 0.907002C6.03638 1.31512 5.84915 1.79973 5.77918 2.31333C3.85914 2.63849 3.61108 4.90856 3.61108 4.90856L5.15706 4.0814"
      fill="url(#paint2_linear_2264_24866)"
    />
    <path
      d="M7.75726 11.5477C6.93279 10.4103 6.39991 9.04237 6.21586 7.59099C6.14629 7.04928 6.12542 6.50178 6.15265 5.95673L5.92288 5.69224L5.05926 4.69559L3.91478 5.30598C3.81183 6.04906 3.80805 6.80508 3.90365 7.54951C4.0728 8.8847 4.56295 10.1432 5.32162 11.1896C6.06599 12.178 7.01826 12.9427 8.09237 13.4139C8.3448 13.533 8.60419 13.6322 8.86854 13.7114C9.12474 13.7997 9.38612 13.8673 9.65087 13.9139C10.042 13.9844 10.438 14.0116 10.8333 13.9955C10.8118 13.9857 10.7904 13.9759 10.7689 13.9659C9.60138 13.4536 8.56622 12.6222 7.75726 11.5477Z"
      fill="url(#paint3_linear_2264_24866)"
    />
    <path
      d="M2.28676 4.72033C2.28676 4.72033 2.44339 3.28769 3.44157 2.44915C3.32549 2.39942 3.20564 2.36017 3.083 2.33274C3.13647 2.04728 3.24798 1.77944 3.40897 1.55018C3.67492 1.21231 4.05535 1.01583 4.45705 1.0087L4.38768 0C4.06747 0.0124888 3.75323 0.0996877 3.46463 0.255798C3.17622 0.411909 2.91982 0.633808 2.71171 0.907002C2.4253 1.31512 2.23806 1.79973 2.1681 2.31333C0.248055 2.63849 0 4.90856 0 4.90856L1.54597 4.0814"
      fill="url(#paint4_linear_2264_24866)"
    />
    <path
      d="M4.14617 11.5477C3.32171 10.4103 2.78883 9.04237 2.60477 7.59099C2.53521 7.04928 2.51434 6.50178 2.54157 5.95673L2.3118 5.69224L1.44817 4.69559L0.303701 5.30598C0.200742 6.04906 0.196965 6.80508 0.29257 7.54951C0.461717 8.8847 0.951865 10.1432 1.71054 11.1896C2.45491 12.178 3.40718 12.9427 4.48129 13.4139C4.73372 13.533 4.9931 13.6322 5.25745 13.7114C5.51366 13.7997 5.77503 13.8673 6.03978 13.9139C6.43095 13.9844 6.82688 14.0116 7.22222 13.9955C7.20076 13.9857 7.17929 13.9759 7.15782 13.9659C5.99029 13.4536 4.95514 12.6222 4.14617 11.5477Z"
      fill="url(#paint5_linear_2264_24866)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2264_24866"
        x1={10.1111}
        y1={0}
        x2={10.1111}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2264_24866"
        x1={10.1111}
        y1={0}
        x2={10.1111}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2264_24866"
        x1={6.01849}
        y1={0}
        x2={6.01849}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2264_24866"
        x1={6.01849}
        y1={0}
        x2={6.01849}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2264_24866"
        x1={2.40741}
        y1={0}
        x2={2.40741}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2264_24866"
        x1={2.40741}
        y1={0}
        x2={2.40741}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredVolatilityHigh)
const IconSvgColouredVolatilityHigh = createIcon(
  ForwardRef,
  'SvgColouredVolatilityHigh',
)
export default IconSvgColouredVolatilityHigh
